import React from "react";
import ctbg from "../../assets/images/ctd.png";
import { Link } from "react-router-dom";

const locations = [
  {
    city: "Madurai",
    address: "No. 1, Dr. Varatharajalu Naidu Road,\nKamarajar Nagar 4th St,\nChinna Chokkikulam,\nMadurai - 625002, Tamil Nadu, India",
    phone: "+91 9994174786",
    directions: "https://maps.app.goo.gl/uWayGhsCkq8iUztD7",
  },
  {
    city: "Karnataka",
    address: "SARASU\n#7, 100ft. Ring Road 4th Block,\n3rd Phase BSK 3rd Stage,\nBengaluru - 560 085",
    phone: null,
    directions: "https://maps.app.goo.gl/CuUnT1U27uRHrNaeA",
  },
  {
    city: "Coimbatore",
    address: "No.36/1, Raghav Tower, Amman Nagar,\nSaravanampatti,\nCoimbatore - 641035, Tamil Nadu, India",
    phone: "+91 7339110765",
    email: "info@smartproservice.com",
    directions: null,
  },
];

function Contactuspage() {
  return (
    <div>
      {/* ── Hero banner ── */}
      <div
        style={{
          backgroundImage: `url(${ctbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: 220,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
          }}
        />
        <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <p
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.7)",
              marginBottom: "0.5rem",
            }}
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            Reach out
          </p>
          <h1
            style={{
              color: "#fff",
              fontWeight: 800,
              fontSize: "clamp(1.8rem, 4vw, 2.8rem)",
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              margin: 0,
              textShadow: "0 2px 16px rgba(0,0,0,0.4)",
            }}
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            Contact Us
          </h1>
        </div>
      </div>

      {/* ── Location cards ── */}
      <div className="bg-white py-5">
        <div className="container" style={{ maxWidth: 1100 }}>

          {/* Section heading */}
          <div className="text-center mb-5">
            <p
              style={{
                fontSize: "0.7rem",
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "#563D7C",
                marginBottom: "0.5rem",
              }}
            >
              Find us
            </p>
            <h2
              style={{
                fontWeight: 800,
                color: "#1a1a2e",
                fontSize: "clamp(1.4rem, 3vw, 2rem)",
                marginBottom: "0.75rem",
              }}
            >
              Our Locations
            </h2>
            <div
              style={{
                width: 48,
                height: 3,
                background: "#563D7C",
                borderRadius: 2,
                margin: "0 auto",
                opacity: 0.5,
              }}
            />
          </div>

          <div className="row g-4 justify-content-center">
            {locations.map(({ city, address, phone, email, directions }) => (
              <div key={city} className="col-12 col-md-6 col-lg-4">
                <div
                  style={{
                    height: "100%",
                    borderRadius: 16,
                    border: "1px solid rgba(86,61,124,0.1)",
                    boxShadow: "0 2px 16px rgba(86,61,124,0.06)",
                    padding: "2rem 1.75rem",
                    background: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                  }}
                >
                  {/* City */}
                  <h4
                    style={{
                      fontWeight: 800,
                      color: "#563D7C",
                      fontSize: "1.1rem",
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {city}
                  </h4>

                  <div
                    style={{
                      width: 32,
                      height: 2,
                      background: "#563D7C",
                      borderRadius: 2,
                      opacity: 0.4,
                    }}
                  />

                  {/* Address */}
                  <p
                    style={{
                      fontSize: "0.875rem",
                      color: "#555",
                      lineHeight: 1.8,
                      margin: 0,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {address}
                  </p>

                  {/* Phone */}
                  {phone && (
                    <p style={{ fontSize: "0.855rem", color: "#555", margin: 0 }}>
                      <span style={{ fontWeight: 600, color: "#444" }}>Ph:</span> {phone}
                    </p>
                  )}

                  {/* Email */}
                  {email && (
                    <p style={{ fontSize: "0.855rem", color: "#555", margin: 0 }}>
                      <span style={{ fontWeight: 600, color: "#444" }}>Email:</span>{" "}
                      <a href={`mailto:${email}`} style={{ color: "#563D7C", textDecoration: "none" }}>
                        {email}
                      </a>
                    </p>
                  )}

                  {/* Get Directions */}
                  {directions && (
                    <div style={{ marginTop: "auto", paddingTop: "0.5rem" }}>
                      <a
                        href={directions}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          background: "#563D7C",
                          color: "#fff",
                          fontWeight: 700,
                          fontSize: "0.78rem",
                          letterSpacing: "0.04em",
                          padding: "0.55rem 1.3rem",
                          borderRadius: 50,
                          textDecoration: "none",
                          transition: "background 0.2s, transform 0.2s",
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.background = "#7b5ea7";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.background = "#563D7C";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        Get Directions →
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contactuspage;